import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'

import Headline from 'components/Headline'
import TopNav from 'components/TopNav'
import BeginForm from 'components/BeginForm'
import RevisedBeginForm from 'components/RevisedBeginForm'
import parseStringData from './common/parseStringData'
import DeviceId from 'utils/detectDevice'
import { setBackground } from './common/createStyle'
import { domainName } from 'utils/parseDomain'

const showRevisedBeginForm = strDomain =>
  [
    'marathishaadi.com',
    'bengalishaadi.com',
    'punjabishaadi.com',
    'gujaratishaadi.com',
    'telugushaadi.com',
    'kannadashaadi.com',
    'tamilshaadi.com',
    'muslimshaadi.in',
  ].includes(strDomain)

const BannerContainer = styled.div`
  width: 100%;
  background-size: cover !important;
  ${setBackground}
`
const HomeBanner = props => {
  const {
    data: {
      airtable: {
        fields: {
          webCreatives,
          mobileCreatives,
          domainLogo,
          logoDimension,
          showSixMillion,
          domainReligion,
          domainLanguage,
          topNavRightColor,
        },
      },
    },
  } = props
  const dimensionData = parseStringData(logoDimension)
  const [state, setState] = useState({ bannerUrl: '', logoDimensions: '' })
  useEffect(() => {
    const logoDimensions = DeviceId.isDesktop()
      ? dimensionData.desktop
      : dimensionData.mobile
    const arrCreatives = DeviceId.isDesktop()
      ? parseStringData(webCreatives)
      : parseStringData(mobileCreatives)
    let bannerUrl = arrCreatives[0]
    if (arrCreatives.length > 1) {
      bannerUrl = arrCreatives[Math.floor(Math.random() * arrCreatives.length)]
    }
    setState({ bannerUrl, logoDimensions })
  }, [])

  return (
    <BannerContainer backgroundUrl={state.bannerUrl}>
      <TopNav
        domainLogo={domainLogo}
        logoDimension={state.logoDimensions}
        showSixMillion={showSixMillion}
        topNavRightColor={topNavRightColor}
      />
      <div className="container">
        <div className="row">
          <Headline content={props.data.airtable.data.leading_copy_line1} />
          {!showRevisedBeginForm(domainName) && (
            <BeginForm
              domainReligion={domainReligion}
              domainLanguage={domainLanguage}
            />
          )}
          {showRevisedBeginForm(domainName) && <RevisedBeginForm />}
        </div>
      </div>
    </BannerContainer>
  )
}

export default HomeBanner
